import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { useEffect } from "react";

import { startSignalR } from "./signalr";   // ⭐ Correct import location

import Devices from "./pages/Devices";
import Home from "./pages/Home";
import DeviceDetails from "./pages/DeviceDetails";

function App() {

  useEffect(() => {
    // Start SignalR connection once when the app loads
    startSignalR();
  }, []);

  return (
    <Router>
      <div style={{ padding: 10, background: "#eee" }}>
        <Link to="/" style={{ marginRight: 20 }}>Home</Link>
        <Link to="/devices">Devices</Link>
      </div>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/devices/:deviceId" element={<DeviceDetails />} />
      </Routes>
    </Router>
  );
}

export default App;
